import { Controller } from "@hotwired/stimulus"

// Draws the coordinate trail for the cell under the pointer: its column from the
// day header down to it, and its row from the Regulär or Abwesenheit label
// across to it. The trail stops at the cell rather than running the full width
// and height, and the cell itself is marked apart from the run leading up to it,
// so it reads as "this is where you are" instead of tinting a whole cross.
//
// CSS could do neither half on its own — a column has no selector, and a row
// would need to reach its preceding cells. Purely presentational: nothing is
// read from the cell and nothing is stored.
export default class extends Controller {
  static classes = ["trail", "trailHead"]

  connect() {
    this.trailed = new Set()
    this.current = null
  }

  disconnect() {
    this.clear()
  }

  trace(event) {
    const cell = event.target.closest("[data-day]")

    if (cell === this.current) return

    this.clear()
    this.current = cell
    if (!cell) return

    // querySelectorAll answers in document order, so the day header comes first
    // and the employees follow top to bottom — breaking at the hovered cell
    // leaves exactly the stretch above it marked.
    this.#mark(this.element.querySelectorAll(`[data-day="${cell.dataset.day}"]`), cell)
    this.#mark(cell.parentElement.children, cell)

    cell.classList.add(...this.trailHeadClasses)
    this.trailed.add(cell)
  }

  clear() {
    for (const cell of this.trailed) {
      cell.classList.remove(...this.trailClasses, ...this.trailHeadClasses)
    }

    this.trailed.clear()
    this.current = null
  }

  #mark(candidates, last) {
    for (const candidate of candidates) {
      // The employee's name spans both of its rows, so marking it would light
      // the Abwesenheit row up along with the Regulär one the pointer is in.
      if (candidate.rowSpan === 1) {
        candidate.classList.add(...this.trailClasses)
        this.trailed.add(candidate)
      }

      if (candidate === last) return
    }
  }
}
